import Home from '@/components/index'

export default [
    {
        name: 'index',
        path: '/',
        component: Home,
    }
]


// WEBPACK FOOTER //
// ./src/router/home/index.js